export const OwnerOperatorTypes = {
    ownerOperator: 'OwnerOperator',
    employeeDriver: 'EmployeeDriver',
};
